/**
 * blockRegistry: `{ type: displayComponent }` map derived from the canonical
 * blockDefinitions module.
 *
 * A `type` not present in this map is treated as unknown: the renderer skips
 * it rather than crashing, so a newer authored block type degrades safely on
 * an older client.
 */
import BLOCK_DEFINITIONS from './blockDefinitions';

const blockRegistry = Object.fromEntries(
    BLOCK_DEFINITIONS.map(({ type, displayComponent }) => [
        type,
        displayComponent,
    ])
);

/**
 * Resolve the component for a block type.
 *
 * @param {string} type - A block `type` value.
 * @returns {React.ComponentType|null} The component, or null if `type` is not
 *   a known block type.
 */
export const getBlockComponent = (type) => blockRegistry[type] || null;

export default blockRegistry;
